module.exports = __webpack_public_path__ + "static/img/product-swipe14.900ccfaa.png";